var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortByAlphaDesc = function SvgSortByAlphaDesc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.76 19.328 6.49 9.75h1.593l3.711 9.577h-1.588l-.87-2.381H5.218l-.876 2.38zm2.923-3.677H8.82l-1.488-4.173h-.131zm8.68 3.677v-1.42l5.128-6.8h-4.927V9.751h6.627v1.419l-5.097 6.8h5.147v1.358zM9.684 7.443l2.769-2.77 2.77 2.77z"
  })));
};
export default SvgSortByAlphaDesc;